import { i18n } from '@fs/zion-locale'

export default {
  mapOverlayTitle: () => i18n.t('searchResultsPageMapOverlay.title', 'Select Place From Map'),
  mapMarkerAriaLabel: (markerCount, placeName) =>
    i18n.t('searchResultsPageMapOverlay.markerAriaLabel', '{markerCount} results in {placeName}', {
      markerCount,
      placeName,
    }),
  openOverlay: () => i18n.t('searchResultsPageMapOverlay.openOverlay', 'Open this area in an overlay.'),
}
